import { Input } from "../../ui/input";
import { Textarea } from "../../ui/textarea";
import { ArrowUp, ArrowDown, Trash2 } from "lucide-react";

export const FAQEditor = ({ item, index, total, onChange, onMoveUp, onMoveDown, onRemove }) => (
  <div className="border rounded p-4 space-y-2" data-testid={`seo-faq-item-${index}`}>
    <div className="flex items-center justify-between">
      <p className="text-xs text-muted-foreground uppercase tracking-wider">Pregunta {index + 1}</p>
      <div className="flex gap-2">
        <button data-testid={`seo-faq-move-up-${index}`} onClick={onMoveUp} disabled={index === 0} className="disabled:opacity-30">
          <ArrowUp size={14} />
        </button>
        <button data-testid={`seo-faq-move-down-${index}`} onClick={onMoveDown} disabled={index === total - 1} className="disabled:opacity-30">
          <ArrowDown size={14} />
        </button>
        <button data-testid={`seo-faq-remove-${index}`} onClick={onRemove}>
          <Trash2 size={14} />
        </button>
      </div>
    </div>
    <Input
      data-testid={`seo-faq-question-${index}`}
      value={item.question}
      onChange={(e) => onChange({ ...item, question: e.target.value })}
      placeholder="Pregunta"
    />
    <Textarea
      data-testid={`seo-faq-answer-${index}`}
      value={item.answer}
      onChange={(e) => onChange({ ...item, answer: e.target.value })}
      placeholder="Respuesta"
    />
  </div>
);
